import { httpClient } from "@/httpClient";
import getPharmacyID from "@/utils/pharmacy_code";
import { MedicalMasterResponseSchema } from "./type";
import { ListMedicalMasterRequest, ListMedicalMasterResponse } from "@/gen/medical_master/list_medical_master_pb";
import { pharmacyClient } from "@/connect";

export const getMedicalMasterItems = async (page: number, pageSize: number, search: string): Promise<ListMedicalMasterResponse> => {
    return await pharmacyClient.listMedicalMaster({
        page,
        pageSize,
        search: search,
    });
};